<template>
	<v-container class="grey lighten-5 pt-0 mt-0" fluid>
		<v-row align-centre>
			<v-spacer />
			<v-col cols="11">
				<!-- Carousel -->
				<v-row no-gutters>
					<v-col cols="12">
						<v-card class="mb-4">
							<v-carousel cycle continuous interval="5000" height="450px">
								<!--Slide 1-->
								<v-carousel-item :src="require('../assets/photos/backgrounds/DSCF0981.jpeg')">
									<v-row class="fill-height" align="center" justify="center">
										<v-col cols="12">
											<v-spacer />
											<div class="display-3 text-center">Welcome To The European Palm Society</div>
										</v-col>
										<v-spacer />
									</v-row>
								</v-carousel-item>

								<!--Slide 2-->
								<v-carousel-item :src="require('../assets/photos/backgrounds/DSC01591.jpeg')">
									<v-card color=" teal" light outlined raised>
										<v-card-title style="color: white">New Website Launching Shortly</v-card-title>
										<v-card-text style="color: white">More details to follow</v-card-text>
									</v-card>
								</v-carousel-item>
							</v-carousel>
						</v-card>
					</v-col>
				</v-row>

				<v-row>
					<!-- Text Column 1 -->
					<v-col cols="12" sm="12">
						<v-card class="pa-2">
							<v-card-title style="word-break: break-word">The EPS Website Is Undergoing A Facelift</v-card-title>
							<v-card-text style="word-break: break-word">
								The European Palm Society (EPS) website is currently down for scheduled maintainence while we work to
								move the site to new servers and give it a bit of a makeover
							</v-card-text>
							<v-card-text style="word-break: break-word">
								The new website will be available shortly. Your login details will be the same, and all of the content
								will still be available
							</v-card-text>
							<v-card-text style="word-break: break-word">
								We'll be sending an update to members shortly when the new site is live. If you need to contact the
								team, you can still get in touch with the admin team on <a
									href="mailto:info@palmsociety.org.uk">info@palmsociety.org.uk</a>
							</v-card-text>
						</v-card>
					</v-col>

				</v-row>
			</v-col>
			<v-spacer />
		</v-row>
	</v-container>
</template>

<script>

export default {
	name: "Holding",
	data: () => ({
	}),
	methods: {
	},
	beforeMount() {
		let siteIsLive = (process.env.VUE_APP_LIVE == "true")
		if (siteIsLive) {
			this.$router.push("/");
		}
	}
}
</script>
